/** Reserved CSV header (lowercase) for per-row assignment start dates. */
export const START_DATE_HEADER_LC = "start date";
/** Reserved CSV header (lowercase) for per-row assignment end dates. */
export const END_DATE_HEADER_LC = "end date";

/**
 * Find a CSV header by exact match to an override, else by reserved lowercase name.
 * Returns the actual header string from `headers` (preserving source casing), or null.
 *
 * Override semantics (wizard session):
 * - `null` / `undefined` — not chosen yet; fall back to the reserved header
 * - `""` — explicit "none" (skip dates even if a reserved header exists)
 * - non-empty — use that CSV header
 */
export function resolveDateColumnHeader(
  headers: string[],
  override: string | null | undefined,
  reservedLc: string,
): string | null {
  if (override === "") {
    return null;
  }
  const trimmed = override?.trim();
  if (trimmed) {
    const byExact = headers.find((h) => h === trimmed);
    if (byExact !== undefined) return byExact;
    const byCi = headers.find((h) => h.toLowerCase() === trimmed.toLowerCase());
    return byCi ?? null;
  }
  return headers.find((h) => h.toLowerCase() === reservedLc) ?? null;
}

/** Detect the reserved Start Date header in a header list, if present. */
export function detectStartDateColumn(headers: string[]): string | null {
  return headers.find((h) => h.toLowerCase() === START_DATE_HEADER_LC) ?? null;
}

/** Detect the reserved End Date header in a header list, if present. */
export function detectEndDateColumn(headers: string[]): string | null {
  return headers.find((h) => h.toLowerCase() === END_DATE_HEADER_LC) ?? null;
}
